import React, { useState, useEffect } from "react";
import ActionButton from "../Buttons/ActionButton";
import UserService from "../../services/UserService";
import Panel from "../Panel";
import { ReactComponent as DeleteSweepIcon } from "../../assets/icons/delete_sweep.svg";
import { useActionDone } from "../../Api/newSockets.api";

type Props = {
  deviceId: string;
};
interface Message {
  msg: string;
  outputs: any;
}

function ManualTerminal(props: Props) {
  // const initial: Message[] = [
  //     {msg: "Logs initialized", outputs: []}
  // ]
  const [messages, addMessages] = useState([
    { msg: "Logs initialized", status: 1, outputs: [] },
  ]);

  const { actionDone } = useActionDone();

  useEffect(() => {
    actionDone && addMessages([...messages, actionDone]);
  }, [actionDone]);

  // UserService.onTriggered = (msg) => {
  //     addMessages([...messages, msg]);
  //   }
  function clearTerminal() {
    addMessages([]);
  }

  const getMessageClass = (status) => {
    switch (status) {
      case 0:
        return "error";
      case 1:
        return "success";
      case 2:
        return "info";
    }
  };

  const buttons = (
    <ActionButton
      className="clear-terminal"
      onClick={clearTerminal}
      icon={<DeleteSweepIcon />}
    />
  );
  return (
    <div>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-around",
          alignItems: "center",
        }}
      >
        <p>Logs</p>
        {buttons}
      </div>
      <div className="terminal">
        <div className="terminal-screen">
          {/* {
                    messages.map((message:any, i:any) => {
                        let line = '> ' + message.msg
                        if (message.outputs) {
                            Object.keys(message.outputs).forEach(function(key) {
                                line += '  keys: ' + key + ', value: ' + message.outputs[key]
                            })
                        }
                        return <div className="terminal-line" key={i} >
                            {line}
                        </div>
                    })
                    } */}
          {messages.map((message: any, i: any) => {
            let line = "> " + message.msg;
            if (message.outputs) {
              Object.keys(message.outputs).forEach(function(key) {
                line += "  keys: " + key + ", value: " + message.outputs[key];
              });
            }
            return (
              <div
                className={`terminal-line ${getMessageClass(message.status)}`}
                key={i}
              >
                {line}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default ManualTerminal;
